import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiConfigService {
  private baseUrl = environment.baseUrl;
  private apiPath = environment.apiPath;

  constructor() { }

  getApiUrl(service: string, countryCode?: string, countryId?: number): string {
    const apiUrl = `${this.baseUrl}${this.apiPath}`;
    switch (service) {
      case 'about':
        return `${apiUrl}/country_office_listing/${countryCode}`;
      case 'hot_topics':
        return `${apiUrl}/tuneme_srh_content_listing/${countryId}`;
      case 'service_provider':
        return `${apiUrl}/srh_service_provider_listing/${countryId}`;
      case 'srh_service_provider_listing':
        return `${apiUrl}/srh_service_provider_listing/${countryId}`;
      case 'appointment':
        return `${apiUrl}/appointment_reminder_resource`;
      case 'get_comments':
        return `${apiUrl}/leave-comment`;
      case 'get_user_comments':
        return `${apiUrl}/user_comments`;
      case 'post_comment':
        return `${apiUrl}/leave_comment_resource`;
      case 'medicine_reminder':
        return `${apiUrl}/medicine_reminder_resource`;
      case 'period_tracker':
        return `${apiUrl}/period-tracker/${countryId}`;
      case 'get_period_tracker_content':
        return `${apiUrl}/period-tracker/${countryId}`;
      case 'get_appointment_reminder_content':
        return `${apiUrl}/appointment-reminder/${countryId}`;
      case 'get_medicine_reminder_content':
        return `${apiUrl}/medicine-reminder/${countryId}`;
      case 'get_recent_tips':
        return `${apiUrl}/srh_user_tips_export`;
      case 'submit_tip':
        return `${apiUrl}/user_tips_response`;
      case 'opinion_survey':
        return `${apiUrl}/opinion_survey_resource`;
      case 'health_assessment_survey':
        return `${apiUrl}/health_assessment_resource`;
      case 'privacy_policy':
        return `${apiUrl}/privacy-policy/${countryId}`;
      case 'terms_of_use':
        return `${apiUrl}/terms-of-use/${countryId}`;
      case 'srh_context_taxonomy_export':
        return `${apiUrl}/srh_context_taxonomy_export`;
      case 'user_survey_export':
        return `${apiUrl}/user_survey_export/${countryId}/*`;
      case 'survey_poll_response':
        return `${apiUrl}/survey_poll_response`;
      default:
        return this.baseUrl;
    }
  }
}